import { render, staticRenderFns } from "./CauHinhList.vue?vue&type=template&id=3313c1a4&"
import script from "./CauHinhList.vue?vue&type=script&lang=js&"
export * from "./CauHinhList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports